export default __webpack_public_path__ + "static/media/coupon_received_on.e57370c5.png";